export default __webpack_public_path__ + "static/media/Boots of the Ostiary.63ac208c.jpg";